import React from 'react';

import Tippy from '@tippyjs/react';

import numOrDefault from 'lib/helpers/numOrDefault';
import { mString } from 'lib/helpers/utility';

const AmountPaidSelf = ({ value, data }) => {
  const surcharge = numOrDefault(data?.surcharge_amount);
  const refunded = numOrDefault(data?.amount_refunded);
  return (
    <Tippy
      className="tippy-dark"
      content={
        <>
          <p>Charge: {mString(numOrDefault(value) + refunded - surcharge)}</p>
          <p>Technology fee: {mString(surcharge)}</p>
        </>
      }>
      <p>
        {mString(numOrDefault(value) + refunded)}
        {!!data?.amount_refunded ? (
          <span className="text-red-600">
            &nbsp; (Refunded:
            <span className="font-bold"> -{mString(refunded)}</span>)
          </span>
        ) : null}
      </p>
    </Tippy>
  );
};

export default AmountPaidSelf;
